import {z} from 'zod';


export const RECURRENCE_FREQUENCY = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  WEEKLY: 'WEEKLY',
  DAILY: 'DAILY',
};
export const RECURRENCE_FREQUENCY_SCHEMA = z.enum([
  RECURRENCE_FREQUENCY.MONTHLY,
  RECURRENCE_FREQUENCY.YEARLY,
  RECURRENCE_FREQUENCY.WEEKLY,
  RECURRENCE_FREQUENCY.DAILY,
]);

export const RECURRENCE_EXPIRY_TYPE = {
  INFINITE: 'INFINITE',
  COUNT: 'COUNT',
  UNTIL: 'UNTIL',
};
export const RECURRENCE_EXPIRY_TYPE_SCHEMA = z.enum([
  RECURRENCE_EXPIRY_TYPE.INFINITE,
  RECURRENCE_EXPIRY_TYPE.COUNT,
  RECURRENCE_EXPIRY_TYPE.UNTIL,
]);

export const RECURRENCE_MODE = {
  SAME_DAY: 'SAME_DAY',
  SPECIFIC_WEEK_DAY: 'SPECIFIC_WEEK_DAY',
};
export const RECURRENCE_MODE_SCHEMA = z.enum([
  RECURRENCE_MODE.SAME_DAY,
  RECURRENCE_MODE.SPECIFIC_WEEK_DAY,
]);

export const RECURRENCE_DAYS = {
  MO: 'MO',
  TU: 'TU',
  WE: 'WE',
  TH: 'TH',
  FR: 'FR',
  SA: 'SA',
  SU: 'SU',
};
export const RECURRENCE_DAYS_SCHEMA = z.enum([
  RECURRENCE_DAYS.MO,
  RECURRENCE_DAYS.TU,
  RECURRENCE_DAYS.WE,
  RECURRENCE_DAYS.TH,
  RECURRENCE_DAYS.FR,
  RECURRENCE_DAYS.SA,
  RECURRENCE_DAYS.SU,
]);

export const MEETING_LOCATION = {
  ZOOM: 'zoom',
  GOOGLE_MEET: 'google_meet',
  MICROSOFT_TEAMS: 'microsoft_teams',
  CUSTOM_LOCATION: 'custom_location',
  PHONE_NUMBER: 'phone_number',
};
export const MEETING_LOCATION_SCHEMA = z.enum([
  MEETING_LOCATION.ZOOM,
  MEETING_LOCATION.GOOGLE_MEET,
  MEETING_LOCATION.MICROSOFT_TEAMS,
  MEETING_LOCATION.CUSTOM_LOCATION,
  MEETING_LOCATION.PHONE_NUMBER,
]);

export type RecurrenceMode = z.infer<typeof RECURRENCE_MODE_SCHEMA>;
export type RecurrenceDays = z.infer<typeof RECURRENCE_DAYS_SCHEMA>;
export type RecurrenceFrequency = z.infer<typeof RECURRENCE_FREQUENCY_SCHEMA>;
export type RecurrenceExpiryType = z.infer<
  typeof RECURRENCE_EXPIRY_TYPE_SCHEMA
>;
export type MeetingLocation = z.infer<typeof MEETING_LOCATION_SCHEMA>;
